<template>
  <b-form
    v-if="views"
    inline
  >
    <label
      class="mr-sm-2"
      for="inline-form-custom-select-pref"
    >
      View:
    </label>
    <b-form-select
      id="mdmViewsDropdown"
      class="mb-2 mr-sm-2 mb-sm-0"
      :options="views"
      :value="selectedView.viewGuid"
      @change="chooseView"
    />
  </b-form>
</template>
<script>

import {createNamespacedHelpers} from 'vuex';
import {SELECT_MDM_VIEW} from '@/store/modules/data-management/mutation-types';

const {mapState, mapActions, mapMutations, mapGetters} = createNamespacedHelpers('dataManagement');
export default {
  name: 'EntityViewsDropdown',
  data: () => ({
    views: null,
  }),
  watch: {
    tableViews: {
      handler(val) {
        const map = {};
        val.forEach(el => {
          map[el.viewName] = {
            ...el,
            isSelected: el.isSelected,
            text: el.viewName + (el.isDefault ? ' (default)' : ''),
            value: el.viewGuid || '',
          };
        });
        this.views = Object.values(map);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      selectedView: 'selectedMDMView',
    }),
    ...mapState({
      tableViews: state => state.table.views,
    }),
  },
  methods: {
    ...mapMutations([SELECT_MDM_VIEW]),
    chooseView(uuid, makeRequest = true) {
      const view = this.views.find(el => el.viewGuid === uuid);
      this[SELECT_MDM_VIEW](view.viewGuid); // Set isSelected property on table views

      if(view &&  view.viewGuid) {
        const query = {...this.$route.query};
        delete query.filters;
        this.$router.push({query: {...query, view: view.viewGuid}});
      } else {
        const tmpQuery = {...this.$route.query};
        delete tmpQuery.view;
        this.$router.push({query: tmpQuery});
      }

      this.$emit('view-choose', {view, makeRequest});
    },
  },
};
</script>

<style scoped lang="scss">
.views-dropdown {
  width: 360px;
  padding: 0;
  margin: 0;

  .b-dropdown-form {
    padding: 0;
  }

  .edit-icon, .delete-icon {
    cursor: pointer;
  }
}
</style>